<template>
  <div id="app" class="h-100">
    <router-view/>
  </div>
</template>
<script>


export default {
  name: 'LiveStatics',
  components: {},
  data() {
    return {
      isMenuOpen: false
    }
  },
  methods: {},
  mounted() {
    /* var vhHeight = $("body").height();
 var chromeNavbarHeight = vhHeight - window.innerHeight;
 $('body').css({ height: window.innerHeight, marginTop: chromeNavbarHeight });
*/
// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);

// We listen to the resize event
    window.addEventListener('resize', () => {
      // We execute the same script as before
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    });
  }
}
</script>
<style>

</style>
